<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">VENTAS</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>REPORTE GENERAL DE VENTAS</strong>
      </span>
    </div>

    <!-- FILTROS -->
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-2">
          <span><strong>SUCURSAL: </strong></span>
          <Dropdown v-model="sucursalSelected" :options="sucursales" optionLabel="nombre" optionValue="id" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>CÓDIGO VENTA: </strong></span>
          <InputNumber
            v-model="codigoVenta"
            placeholder="Código Venta"
            :inputClass="'text-right'"
            :min="0"
            :useGrouping="false"
            @keyup.enter="BuscarFiltro"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>CÓDIGO CAJA: </strong></span>
          <InputNumber
            v-model="codigoCaja"
            placeholder="Código Caja"
            :inputClass="'text-right'"
            :min="0"
            :useGrouping="false"
            @keyup.enter="BuscarFiltro"
          />
        </div>

        <div class="field col-12 md:col-4">
          <span>
            <strong>{{ tipo_negocio == 2 ? 'BUSCAR CLIENTE/PLACA:' : 'BUSCAR CLIENTE:' }}</strong>
          </span>
          <div class="p-inputgroup">
            <AutoComplete
              :field="tipo_negocio == 2 ? 'placa' : 'nombre'"
              v-model="clienteSelected"
              :suggestions="clientesListadoFiltrado"
              @complete="buscarCliente($event)"
              :placeholder="tipo_negocio == 2 ? 'Buscar por placa o cliente...' : 'Buscar cliente...'"
            />
            <Button
              :disabled="!clienteSelected"
              icon="pi pi-search"
              class="p-button-warning"
              @click="buscarCliente($event)"
              v-tooltip.top="'Buscar'"
            />
          </div>
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>TRABAJADOR: </strong></span>
          <Dropdown v-model="medicoSelected" :options="medicos" optionLabel="nombre_completo" optionValue="id" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>CAJERO: </strong></span>
          <Dropdown v-model="userSeleccionado" :options="users" optionLabel="name" optionValue="id" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>ESTADO VENTA: </strong></span>
          <Dropdown v-model="estadoSelected" :options="estados" optionLabel="nombre" optionValue="id" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>M. DE PAGO: </strong></span>
          <Dropdown v-model="metodoPagoSelected" :options="metodo_pagos" optionLabel="nombre" optionValue="id" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>FECHA INICIO: </strong></span>
          <!-- <InputText type="date" v-model="fecha_inicio" :min="fechaMinimaPermitida" dateFormat="dd/mm/yy" /> -->
          <Calendar v-model="fecha_inicio" dateFormat="dd/mm/yy" :showIcon="true" :minDate="fechaMinimaPermitida" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>FECHA FIN: </strong></span>
          <!-- <InputText type="date" v-model="fecha_fin" :min="fechaMinimaPermitida" dateFormat="dd/mm/yy" /> -->
          <Calendar v-model="fecha_fin" :showIcon="true" dateFormat="dd/mm/yy" :minDate="fechaMinimaPermitida" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Buscar'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>

    <!-- TOTALES GENERALES -->
    <div class="mt-4 card style_card" v-if="ventas.length > 0">
      <div class="p-fluid formgrid grid">
        <table class="table table-bordered table-striped" style="width: 100%">
          <tr>
            <th class="text-center">
              TOTAL VENTAS:
              <span class="p-badge p-badge-blue p-mr-2" style="font-size: 1rem">
                {{ convertirNumeroGermanicFormat(totalesGenerales.total_venta + totalesGenerales.total_descuento) }}
                Bs.
              </span>
            </th>
            <th class="text-center">
              VENTAS CRÉDITO:
              <span class="p-badge p-badge-danger p-mr-2" style="font-size: 1rem">
                {{ convertirNumeroGermanicFormat(totalesGenerales.total_credito) }}
                Bs.
              </span>
            </th>
            <th class="text-center">
              TOTAL DESCUENTOS:
              <span class="p-badge p-badge-danger p-mr-2" style="font-size: 1rem">
                {{ convertirNumeroGermanicFormat(totalesGenerales.total_descuento) }}
                Bs.
              </span>
            </th>
            <th class="text-center">
              TOTAL GENERAL:
              <span class="p-badge p-badge-success p-mr-2" style="font-size: 1rem">
                {{ convertirNumeroGermanicFormat(totalesGenerales.total_venta - totalesGenerales.total_credito) }}
                Bs.
              </span>
            </th>
          </tr>
        </table>
      </div>

      <div class="mt-2 text-center text-sm text-secondary">
        <i class="pi pi-info-circle mr-2"></i>
        Los totales son del filtro completo ({{ totalRegistros }} registros). Mostrando página {{ paginaActual }} de
        {{ Math.ceil(totalRegistros / porPagina) }}
      </div>
    </div>

    <!-- DATATABLE CON PAGINACIÓN -->
    <div class="mt-4">
      <DataTable
        ref="reporte_ventas"
        key="id"
        :value="ventas"
        :lazy="true"
        :paginator="true"
        :rows="porPagina"
        :totalRecords="totalRegistros"
        :loading="enviando"
        @page="onPageChange"
        :rowsPerPageOptions="[25, 50, 100, 200]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        stripedRows
        showGridlines
        v-model:expandedRows="expandedRows"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left" v-if="'R_Ventas de Ventas' in auth.user.permissions">
              <Button text icon="pi pi-minus" label="Contraer Todo" @click="collapseAll" class="mr-2 p-button-info" />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left" v-if="'R_Ventas de Ventas' in auth.user.permissions">
              <Button text icon="pi pi-plus" label="Expandir Todo" @click="expandAll" class="mr-2 p-button-info" />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'R_Ventas DescargarPDF' in auth.user.permissions"
                label="PDF Imprimir"
                icon="pi pi-file-pdf"
                class="p-button-outlined p-button-danger mr-2"
                v-tooltip.top="'Imprimir Reporte PDF'"
                :loading="generandoPDF"
                :disabled="generandoPDF || ventas.length === 0"
                @click="generarPDF"
              />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'R_Ventas DescargarEXCEL' in auth.user.permissions"
                label="EXCEL Exportar"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success"
                v-tooltip.top="'Imprimir Reporte Excel'"
                :loading="exportando"
                :disabled="exportando || ventas.length === 0"
                @click="exportVentas"
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center p-4">
            <ProgressSpinner />
            <span class="ml-3">Cargando ventas...</span>
          </div>
        </template>

        <template #empty>
          <div class="text-center p-4">
            <i class="pi pi-info-circle" style="font-size: 2rem; color: #64748b"></i>
            <p class="mt-2 text-secondary">Debe aplicar filtros para ver resultados en la tabla</p>
          </div>
        </template>

        <Column expander style="width: 1rem" v-if="'R_Ventas de Ventas' in auth.user.permissions"></Column>

        <Column class="text-right" field="id" header="CÓD"></Column>

        <Column field="usuario" header="USUARIO"></Column>

        <Column field="fecha_venta" header="FECHA VENTA"></Column>

        <Column field="nombre_cliente" header="CLIENTE">
          <template #body="{ data }">
            <span v-if="data.tipo_negocio == 2">
              <span>{{ data.nombre_cliente }}</span>
              <strong> - Placa: </strong>
              <span>{{ data.placa_vehiculo ?? '-' }}</span>
            </span>
            <span v-else>
              {{ data.nombre_cliente }}
            </span>
          </template>
        </Column>

        <Column field="nit" header="CI/NIT"></Column>

        <Column field="descuento" header="DESC." class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.descuento) }}
          </template>
        </Column>

        <Column field="efectivo" header="EFECTIVO" class="text-right" style="width: 20px; font-weight: bold">
          <template #body="{ data }">
            <span v-tooltip.top="'Efectivo'">
              {{ convertirNumeroGermanicFormat(data.efectivo) }}
            </span>
          </template>
        </Column>

        <Column
          field="transferencias"
          header="TRANSF."
          class="text-right"
          style="width: 20px; font-weight: bold"
          v-if="total_transferencia > 0"
        >
          <template #body="{ data }">
            <span v-tooltip.top="'Transferencias/Qr'">
              {{ convertirNumeroGermanicFormat(data.transferencias) }}
            </span>
          </template>
        </Column>

        <Column field="total_cancelar" header="T.VENTA" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.total_cancelar) }}
          </template>
        </Column>

        <Column field="facturado" header="ENVIADO" class="text-center" v-if="'Venta Facturar' in auth.user.permissions">
          <template #body="{ data }">
            <span
              class="product-badge status"
              :class="{
                'status-outofstock': data.facturado === 0,
                'status-instock': data.facturado === 1
              }"
            >
              {{ textoFacturado(data.facturado) }}
            </span>
          </template>
        </Column>

        <Column
          field="fact_indicador"
          header="FACTURA"
          class="text-center"
          v-if="'Venta FactIndicador' in auth.user.permissions"
        >
          <template #body="{ data }">
            <span
              class="product-badge status"
              :class="{
                'status-outofstock': data.fact_indicador === 0,
                'status-instock': data.fact_indicador === 1
              }"
            >
              {{ textoFacturado(data.fact_indicador) }}
            </span>
          </template>
        </Column>

        <Column field="nombre_medico" header="TRABAJADOR" v-if="medicoSelected">
          <template #body="{ data }">
            {{ data.nombre_medico ?? '-' }}
          </template>
        </Column>

        <Column field="productos_servicios" header="PROD./SERV." v-if="mostrar_prod_serv_rep_venta">
          <template #body="{ data }">
            <span
              v-tooltip.top="
                data.productos_servicios && data.productos_servicios.length > 20 ? data.productos_servicios : ''
              "
            >
              {{
                data.productos_servicios
                  ? data.productos_servicios.length > 20
                    ? data.productos_servicios.substring(0, 20) + '...'
                    : data.productos_servicios
                  : ''
              }}
            </span>
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span
              class="product-badge status"
              :class="{
                'status-outofstock': data.estado === 0,
                'status-instock': data.estado === 1
              }"
            >
              {{ textoEstado(data.estado) }}
            </span>
          </template>
        </Column>

        <ColumnGroup type="footer">
          <Row>
            <Column footer="TOTALES PÁGINA:" class="text-right" :colspan="7" />
            <Column class="text-right" :footer="convertirNumeroGermanicFormat(total_efectivo)" />
            <Column class="text-right" :footer="convertirNumeroGermanicFormat(total_transferencia)" />
          </Row>
        </ColumnGroup>

        <Column style="width: 3rem">
          <template #header>
            <strong>
              <i class="pi pi-cog" v-tooltip.top="'ACCIONES'" style="font-size: 1.6rem"></i>
            </strong>
          </template>
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised p-button-info"
              icon="pi pi-ellipsis-v"
              v-tooltip.top="'Ver Acciones'"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)" />
          </template>
        </Column>

        <template #expansion="slotProps" v-if="'R_Ventas de Ventas' in auth.user.permissions">
          <div class="p-3">
            <h5>
              <span style="border-bottom: 1px solid #ccc">
                DETALLE DE VENTA:
                <strong>{{ slotProps.data.id }} - {{ slotProps.data.razon_social }}</strong>
              </span>
            </h5>

            <div v-if="!slotProps.data.productos" class="text-center p-4">
              <ProgressSpinner style="width: 30px; height: 30px" />
              <p class="mt-2">Cargando productos...</p>
            </div>

            <DataTable
              v-else
              :value="slotProps.data.productos"
              class="p-datatable-sm"
              responsiveLayout="scroll"
              stripedRows
              showGridlines
            >
              <Column field="id" header="COD_PROD" class="text-center"></Column>
              <Column
                field="descripcion"
                header="PRODUCTO/DESCRIPCIÓN"
                style="width: 300px; font-weight: bold"
              ></Column>
              <Column header="CANTIDAD" class="text-right">
                <template #body="slotProps">
                  {{ slotProps.data.cantidad }}
                </template>
              </Column>
              <Column header="PRECIO" class="text-right">
                <template #body="slotProps">
                  {{ convertirNumeroGermanicFormat(slotProps.data.precio) }}
                </template>
              </Column>
              <Column header="SUBTOTAL" class="text-right">
                <template #body="slotProps">
                  {{ convertirNumeroGermanicFormat(slotProps.data.cantidad * slotProps.data.precio) }}
                </template>
              </Column>
              <Column header="DESCUENTO" class="text-right">
                <template #body="slotProps">
                  {{ convertirNumeroGermanicFormat(slotProps.data.descuento_neto) }}
                </template>
              </Column>
              <Column header="TOTAL" class="text-right">
                <template #body="slotProps">
                  {{
                    convertirNumeroGermanicFormat(
                      slotProps.data.cantidad * slotProps.data.precio - slotProps.data.descuento_neto
                    )
                  }}
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>

      <VentaFacturar
        v-if="ventafacturaDialog"
        :show="ventafacturaDialog"
        :ventaFactura="ventaFactura"
        @closeModal="ocultarDialog"
        @actualizarListado="BuscarFiltro"
      />
    </div>
  </div>
</template>

<script>
import VentaService from '@/service/VentaService'
import ClienteService from '@/service/ClienteService'
import { useAuth } from '@/stores'
import VentaFacturar from '@/module/ventas/VentaFacturar.vue'

export default {
  components: { VentaFacturar },
  data() {
    const haceUnaSemana = new Date()
    haceUnaSemana.setDate(haceUnaSemana.getDate() - 7)
    return {
      fecha_inicio: null,
      fecha_fin: null,
      enviando: false,
      ventas: [],
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: 'TODAS' }],
      userSeleccionado: 0,
      users: [{ id: 0, name: 'TODOS' }],
      medicoSelected: 0,
      medicos: [{ id: 0, nombre_completo: 'TODOS' }],
      paqueteSelected: 0,
      paquetes: [{ id: 0, nombre: 'TODOS' }],
      generandoPDF: false,
      exportando: false,
      clienteSelected: null,
      clientesListadoFiltrado: [],
      estadoSelected: 2,
      estados: [
        { id: 2, nombre: 'TODOS' },
        { id: 1, nombre: 'VALIDA' },
        { id: 0, nombre: 'ANULADA' }
      ],
      codigoVenta: null,
      codigoCaja: null,
      ventaFactura: {},
      ventafacturaDialog: false,
      expandedRows: [],
      metodo_pagos: [],
      metodoPagoSelected: 0,
      mostrar_prod_serv_rep_venta: false,

      // PAGINACIÓN
      paginaActual: 1,
      porPagina: 50,
      totalRegistros: 0,

      // TOTALES GENERALES
      totalesGenerales: {
        total_venta: 0,
        total_descuento: 0,
        total_efectivo: 0,
        total_transferencia: 0,
        total_credito: 0
      },
      tipo_negocio: null
    }
  },

  computed: {
    // TOTALES DE LA PÁGINA ACTUAL
    total_efectivo() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.efectivo || 0), 0)
    },

    total_transferencia() {
      return this.ventas.filter((v) => v.estado == 1).reduce((sum, v) => sum + parseFloat(v.transferencias || 0), 0)
    },
    esSupervisor() {
      const roles = this.auth.user.roles

      if (!roles || !Array.isArray(roles)) return false

      return roles.some((rol) => {
        if (typeof rol === 'string') {
          return rol.toLowerCase() === 'supervisor'
        }

        if (typeof rol === 'object' && rol.name) {
          return rol.name.toLowerCase() === 'supervisor'
        }

        return false
      })
    },
    fechaMinimaPermitida() {
      if (this.esSupervisor) {
        const date = new Date()
        date.setDate(date.getDate() - 7)
        return date
      }
      return null
    }
  },

  created() {
    this.ventaService = new VentaService()
    this.clienteService = new ClienteService()
    this.auth = useAuth()
  },

  mounted() {
    this.datos_necesarios_reporte_ventas()
  },

  methods: {
    onPageChange(event) {
      this.paginaActual = event.page + 1
      this.porPagina = event.rows
      this.cargarReporteVentas()
    },

    datos_necesarios_reporte_ventas() {
      this.ventaService
        .datos_necesarios_reporte_ventas()
        .then((data) => {
          this.sucursales = data.datos.sucursales || []
          this.sucursales.unshift({ id: 0, nombre: 'TODAS' })

          this.users = data.datos.users || []
          this.users.unshift({ id: 0, name: 'TODOS' })

          this.medicos = data.datos.medicos || []
          this.medicos.unshift({ id: 0, nombre_completo: 'TODOS' })

          if (data.datos.paqueteproductos) {
            data.datos.paqueteproductos.forEach((element) => {
              this.paquetes.push(element)
            })
          }

          this.metodo_pagos = data.datos.metodo_pagos || []
          this.metodo_pagos.unshift({ id: 0, nombre: 'TODOS' })

          this.mostrar_prod_serv_rep_venta = data.datos.mostrar_prod_serv_rep_venta || false
          this.tipo_negocio = data.datos.tipo_negocio || null

          // Auto-seleccionar usuario si es Ventas (cajero)
          /* if (!this.esAdminOSuperAdmin()) {
            this.userSeleccionado = this.auth.user.id
          } */
        })
        .catch((error) => {
          console.error('Error cargando datos necesarios:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los datos necesarios',
            life: 3000
          })
        })
    },

    esAdminOSuperAdmin() {
      const roles = this.auth.user.roles

      if (!roles || !Array.isArray(roles)) return false

      return roles.some((rol) => {
        if (typeof rol === 'string') {
          return rol.toLowerCase() === 'super admin' || rol.toLowerCase() === 'administrador'
        }

        if (typeof rol === 'object' && rol.name) {
          return rol.name.toLowerCase() === 'super admin' || rol.name.toLowerCase() === 'administrador'
        }

        return false
      })
    },

    acciones(data) {
      return [
        {
          label: 'Ver Detalle',
          icon: 'pi pi-fw pi-eye',
          disabled: !('Venta Ver Detalle' in this.auth.user.permissions),
          to: `/ventas/${data.id}/detalle`
        },
        {
          label: 'Imprimir',
          icon: 'pi pi-print',
          command: () => this.imprimirVenta(data.id)
        },
        {
          visible: 'Venta Facturar' in this.auth.user.permissions,
          label: 'Crear Factura',
          disabled: data.facturado == 1 || data.estado == 0,
          icon: 'pi pi-fw pi-file',
          command: () => this.ventaFacturar(data)
        }
      ]
    },

    ventaFacturar(venta) {
      this.ventaFactura = {
        ...venta,
        nit: venta.nit && venta.nit !== '0' && venta.nit !== '99001' ? Number(venta.nit) : null
      }
      this.ventafacturaDialog = true
    },

    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch((error) => {
          console.error('Error imprimiendo venta:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo imprimir la venta',
            life: 3000
          })
        })
    },

    ocultarDialog() {
      this.ventafacturaDialog = false
    },

    textoEstado(estado) {
      return estado == 0 ? 'ANULADA' : estado == 1 ? 'VALIDA' : 'PENDIENTE'
    },

    buscarCliente() {
      if (!this.clienteSelected) return

      const texto =
        typeof this.clienteSelected === 'string'
          ? this.clienteSelected
          : this.tipo_negocio == 2
          ? this.clienteSelected.placa
          : this.clienteSelected.nombre

      const datos = {
        texto: texto,
        sucursal_id: this.sucursalSelected == 0 ? 1 : this.sucursalSelected
      }

      this.clienteService
        .buscar(datos)
        .then((response) => {
          if (response.status == 400 || !response.clientes || response.clientes.length == 0) {
            this.$toast.add({
              severity: 'error',
              summary: 'ERROR',
              detail: this.tipo_negocio == 2 ? 'No se encontró el vehículo' : 'No se encontró el cliente',
              life: 3000
            })
            this.clientesListadoFiltrado = []
            return
          }
          this.clientesListadoFiltrado = [...response.clientes]
        })
        .catch((error) => {
          console.error('Error buscando:', error)
          this.clientesListadoFiltrado = []
        })
    },

    exportVentas() {
      if (this.ventas.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para exportar',
          life: 3000
        })
        return
      }

      this.exportando = true
      const datos = {
        sucursal_id: this.sucursalSelected,
        user_id: this.userSeleccionado,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoVenta: this.codigoVenta,
        medico_id: this.medicoSelected,
        nombre_paquete: this.paqueteSelected,
        codigoCaja: this.codigoCaja,
        metodo_pago: this.metodoPagoSelected ?? 0
      }

      this.ventaService
        .exportarVentas(datos)
        .then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Exportación exitosa',
            detail: 'Se ha exportado correctamente',
            life: 3000
          })
        })
        .catch((error) => {
          console.error('Error exportando:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo exportar el reporte',
            life: 3000
          })
        })
        .finally(() => {
          this.exportando = false
        })
    },

    generarPDF() {
      if (this.ventas.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para generar el reporte',
          life: 3000
        })
        return
      }

      this.generandoPDF = true
      const datos = {
        sucursal: this.sucursalSelected,
        user_id: this.userSeleccionado,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoVenta: this.codigoVenta,
        medico_id: this.medicoSelected,
        nombre_paquete: this.paqueteSelected,
        codigoCaja: this.codigoCaja,
        metodo_pago: this.metodoPagoSelected ?? 0
      }

      this.ventaService
        .imprimirPDF(datos)
        .then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Exito',
            detail: 'Se generó el PDF correctamente',
            life: 3000
          })
        })
        .catch((error) => {
          console.error('Error generando PDF:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo generar el PDF',
            life: 3000
          })
        })
        .finally(() => {
          this.generandoPDF = false
        })
    },

    BuscarFiltro() {
      if (this.esSupervisor) {
        const fechaInicioUsuario = new Date(this.fecha_inicio)
        const fechaMinima = new Date(this.fechaMinimaPermitida)

        fechaInicioUsuario.setHours(0, 0, 0, 0)
        fechaMinima.setHours(0, 0, 0, 0)

        if (fechaInicioUsuario < fechaMinima) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Restricción',
            detail: 'Como Supervisor, solo puedes ver reportes de los últimos 7 días.',
            life: 8000
          })
          this.fecha_inicio = this.fechaMinimaPermitida
          return
        }
      }
      this.clientesListadoFiltrado = []
      this.ventas = []
      this.paginaActual = 1
      this.cargarReporteVentas()
    },

    cargarReporteVentas() {
      this.enviando = true

      const datos = {
        sucursal: this.sucursalSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        user_id: this.userSeleccionado,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoVenta: this.codigoVenta,
        medico_id: this.medicoSelected,
        nombre_paquete: this.paqueteSelected,
        codigoCaja: this.codigoCaja,
        metodo_pago: this.metodoPagoSelected ?? 0,
        mostrar_prod_serv_rep_venta: this.mostrar_prod_serv_rep_venta,
        page: this.paginaActual,
        per_page: this.porPagina
      }

      if (this.clienteSelected) {
        if (this.tipo_negocio == 2) {
          // Buscar por vehículo (tiene vehiculo_id y cliente_id)
          datos.vehiculo_id = this.clienteSelected.vehiculo_id || null
          datos.cliente_id = this.clienteSelected.cliente_id || null
        } else {
          // Buscar por cliente
          datos.cliente_id = this.clienteSelected.cliente_id || this.clienteSelected.id || null
        }
      }
      this.ventaService
        .filtrarVentasOptimizado(datos)
        .then((response) => {
          if (response.success) {
            this.ventas = response.ventas || []
            this.totalRegistros = response.pagination?.total || 0

            this.totalesGenerales = {
              total_venta: parseFloat(response.totales_generales?.total_venta || 0),
              total_descuento: parseFloat(response.totales_generales?.total_descuento || 0),
              total_efectivo: parseFloat(response.totales_generales?.total_efectivo || 0),
              total_transferencia: parseFloat(response.totales_generales?.total_transferencia || 0),
              total_credito: parseFloat(response.totales_generales?.total_credito || 0)
            }
          } else {
            this.ventas = []
            this.totalRegistros = 0
          }
        })
        .catch((error) => {
          console.error('Error cargando reporte:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las ventas',
            life: 3000
          })
          this.ventas = []
          this.totalRegistros = 0
        })
        .finally(() => {
          this.enviando = false
        })
    },

    convertirNumeroGermanicFormat(numero) {
      if (!numero && numero !== 0) return '0,00'
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numero)
    },

    textoFacturado(facturado) {
      return facturado == 0 ? 'NO' : 'SI'
    },

    expandAll() {
      this.expandedRows = this.ventas.filter((p) => p.id)
    },

    collapseAll() {
      this.expandedRows = []
    }
  },

  watch: {
    sucursalSelected(newVal) {
      if (newVal > 0) {
        const sucursal = this.sucursales.find((s) => s.id === newVal)
        if (sucursal) {
          this.tipo_negocio = sucursal.tipo_negocio || 1

          // Limpiar búsqueda anterior
          this.clienteSelected = null
          this.clientesListadoFiltrado = []
        }
      } else {
        this.tipo_negocio = 1
      }
    },
    expandedRows(newVal) {
      if (newVal && newVal.length > 0) {
        newVal.forEach((venta) => {
          if (!venta.productos) {
            this.ventaService
              .obtenerProductosVenta(venta.id)
              .then((response) => {
                if (response.success) {
                  venta.productos = response.productos
                  this.$forceUpdate()
                }
              })
              .catch((error) => {
                console.error('Error cargando productos:', error)
              })
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}

.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 3px;
}
</style>
